<template>
  <div
    class="duckMeasurement"
    style="
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 10px;
    "
  >
    <el-card
      shadow="never"
      class="date-time"
      style="min-height: 50px; height: 50px !important"
      >{{ path }}
      <strong style="position: absolute; right: 260px">
        <span>
          <el-popover
            :content="$t('measurement.favoritepopover')"
            placement="bottom"
            trigger="hover"
            width="200"
          >
            <em
              slot="reference"
              id="favorite-button"
              v-loading="favoriteLoading"
              @click="toggleFavorite()"
              style="font-size: 26px; color: #ffd500"
              v-bind:class="favoriteClass"
            ></em>
          </el-popover>
        </span>
      </strong>

      <strong style="position: absolute; right: 100px">
        <span>
          {{ dateDate(measurement.createdAt) }}
        </span>
      </strong>

      <el-dropdown
        @command="handleCommand"
        style="cursor: pointer; position: absolute; right: 50px"
      >
        <span class="el-dropdown-link">
          <em class="el-icon-s-tools" style="font-size: 24px" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-if="checkPermission('deleteMeasurement')"
            command="delete"
          >
            {{ $t("common.delete") }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-card>
    <el-tabs
      type="border-card"
      v-model="mode"
      style="flex: 1; margin-top: 10px"
    >
      <el-tab-pane :label="$t('duck.spectrum')" name="spectrum">
        <DuckSpectrum
          style="flex: 1; display: flex"
          :measurement="measurement"
        ></DuckSpectrum>
      </el-tab-pane>
      <el-tab-pane :label="$t('duck.envelope')" name="envelope">
        <DuckEnvelope
          style="flex: 1; display: flex"
          :measurement="measurement"
        ></DuckEnvelope>
      </el-tab-pane>
      <el-tab-pane :label="$t('duck.cepstrum')" name="cepstrum">
        <DuckCepstrum
          style="flex: 1; display: flex"
          :measurement="measurement"
        ></DuckCepstrum>
      </el-tab-pane>
    </el-tabs>
    <el-row style="margin-top: 10px">
      <el-card>
        <div class="table-title">
          {{ $t("measurement.tags") }}
          <em
            v-if="checkPermission('updateMeasurementTags')"
            class="fas fa-edit edit-tag"
            size="mini"
            @click="editTags()"
            v-show="!tagsEditing"
          ></em>
        </div>
        <el-tag
          disable-transitions
          v-show="!tagsEditing"
          v-for="item in measurement.tags"
          :key="item"
          style="margin-left: 10px; margin-top: 10px"
          >{{ tagLocalization(item) }}</el-tag
        >

        <el-form v-show="tagsEditing">
          <el-form-item>
            <custom-input-tag v-model="tagsForm"></custom-input-tag>
            <br />
            <el-tag
              v-for="item in faultsOptions"
              :key="item.value"
              :type="item.type"
              @click="autoFaultTag(item)"
              effect="dark"
              style="margin: 1px"
            >
              {{ $t(`vibration_analyze_report.${item.value}`) }}
            </el-tag>
          </el-form-item>
          <el-form-item>
            <el-button @click="updateTags()">{{
              $t("measurement.save")
            }}</el-button>
            <el-button @click="tagsEditing = false">{{
              $t("measurement.cancel")
            }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="24">
        <el-table border :data="measurementTelemetries" class="detail-table">
          <el-table-column :label="$t('common.sensor')" prop="telemetry">
            <template slot-scope="scope">{{ sensorName(scope.row) }}</template>
          </el-table-column>
          <el-table-column :label="$t('common.telemetry')" prop="telemetry">
            <template slot-scope="scope">{{
              telemetryDisplayName(scope.row)
            }}</template>
          </el-table-column>
          <el-table-column prop="value" :label="$t('common.value')">
            <template slot-scope="scope"
              >{{ scope.row.value.toFixed(4) }}
              {{ telemetryUnit(scope.row) }}</template
            >
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <br />
  </div>
</template>

<script>
import dayjs from "dayjs-ext";
import measurement from "../service/measurement";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import preferences from "../util/preferences";
import DuckSpectrum from "./DuckSpectrum.vue";
import DuckEnvelope from "./DuckEnvelope.vue";
import DuckCepstrum from "./DuckCepstrum.vue";
import prefaultsOptions from "../util/faultTypes";
import { treeHelper, colorLib } from "../util";

// import dsp from '../../util/dsp'
export default {
  name: "measurement--duck-details",
  components: {
    DuckEnvelope,
    DuckSpectrum,
    DuckCepstrum,
  },
  props: {
    measurement: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      favoriteLoading: false,
      mode: "spectrum",
      selectedSensor: "",
      selectedChannel: "",
      tagsEditing: false,
      tagsForm: [],
    };
  },
  async created() {
    await this.getTelemetry();
  },
  computed: {
    favoriteClass() {
      if (this.measurement && this.measurement.favorite) {
        return "el-icon-star-on";
      }
      return "el-icon-star-off";
    },
    ...mapState("tree", ["flatTree"]),
    ...mapState("admin", ["telemetry"]),
    ...mapState("trend", ["trendCache"]),
    measurementTelemetries() {
      if (!this.measurement) {
        return [];
      } else {
        return this.measurement.telemetry;
      }
    },
    channels() {
      if (!this.measurement || this.selectedSensor == "") {
        return [];
      }
      return this.measurement.config.sensors
        .find((x) => x.groupCode === this.selectedSensor)
        .channels.map((c) => {
          return {
            label: c.channel,
            value: c.order,
            key: c.order,
            disabled: !this.measurement.measurementData.some(
              (x) => x.key === `channel_${c.order}`
            ),
          };
        });
    },
    faultsOptions() {
      return prefaultsOptions.map((x) => {
        return {
          type: "",
          value: x,
        };
      });
    },
    sensors() {
      if (!this.measurement) {
        return [];
      }

      return this.measurement.config.sensors
        .filter((s) => {
          return s.channels.some((c) =>
            this.measurement.measurementData.some(
              (d) => d.key == `channel_${c.order}`
            )
          );
        })
        .map((s) => {
          return {
            label: s.displayName,
            value: s.groupCode,
            key: s.groupCode,
          };
        });
    },
    path () {
      if (this.measurement && this.measurement.point) {
        return treeHelper.pointIdToPath(this.flatTree,this.measurement.point._id);
      } else return "";
    },
  },
  watch: {
    measurement: function (val) {
      if (val) {
        this.load();
      }
    },
  },
  methods: {
    sensorName(measurementTelemetry) {
      if (!this.measurement) {
        return [];
      }
      let sensor = this.measurement.config.sensors.find(
        (x) => x.groupCode == measurementTelemetry.channelGroup
      );
      return sensor.displayName;
    },
    ...mapActions("admin", ["getTelemetry"]),
    telemetryUnit(row) {
      let t = this.telemetry.data.filter((x) => x.hidden == false)[
        this.telemetry.data
          .filter((x) => x.hidden == false)
          .findIndex((x) => x.name == row.telemetry)
      ];
      if (t) {
        return t.unit;
      } else {
        return row.telemetry.unit;
      }
    },
    telemetryDisplayName(v) {
      let telemetryName = v.telemetry;

      let telemetry = this.telemetry.data
        .filter((x) => x.hidden == false)
        .find((x) => v == x.name);
      if (telemetry && telemetry.displayName) {
        telemetryName = telemetry.displayName;
      }
      telemetryName =
        this.$t(`duck.${telemetryName}`) +
        ` (${this.$t("duck." + v.source.trim())})`;
      return telemetryName;
    },
    toggleFavorite() {
      if (this.measurement) {
        let exists =
          this.measurement.favorite != undefined
            ? this.measurement.favorite
            : false;
        let new_value = !exists;
        this.favoriteLoading = true;
        axios
          .put(
            `${process.env.VUE_APP_APIURL}/measurement/${this.measurement._id}/favorite`,
            {
              favorite: new_value,
            }
          )
          .then((res) => {
            this.measurement.favorite = new_value;
          })
          .catch((e) => {
            this.$message.error(e.response.data.message);
          })
          .finally(() => {
            this.favoriteLoading = false;
          });
      }
    },
    handleCommand(command) {
      switch (command) {
        case "delete":
          this.remove();
          break;
      }
    },
    remove() {
      this.$confirm(this.$t("common.AreYouSure"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.warningConfirmText"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          return axios.delete(
            `${process.env.VUE_APP_APIURL}/measurement/${this.$route.params.id}`
          );
        })
        .then(() => {
          if (this.pointId === undefined) {
            this.$router.push("/");
          } else {
            let measurementId = this.$route.params.id;
            let ids = [...this.trend.trend.ids];
            let indexOfMeasurement = ids.indexOf(measurementId);
            if (indexOfMeasurement) {
              ids.splice(indexOfMeasurement, 1);
              if (ids.length) {
                let routingMeasurementId = "";
                if (ids.length >= indexOfMeasurement) {
                  routingMeasurementId = ids[indexOfMeasurement - 1];
                } else {
                  routingMeasurementId = ids[ids.length - 1];
                }

                this.$router.push(`/measurement/${routingMeasurementId}`);
                this.load(routingMeasurementId);

                this.updateTrendCache({
                  ...this.trendCache,
                  measurementId: routingMeasurementId,
                });
                //todo ozan refresh ?
                this.refresh();
              } else {
                this.updateTrendCache("");

                this.$router.push("/");
              }
            } else {
              this.updateTrendCache("");

              this.$router.push("/");
            }
          }
        });
    },

    updateTags() {
      var id = this.$route.params.id;
      let preparedtags = this.tagsForm.map((x) => {
        return x.value;
      });
      axios
        .put(`${process.env.VUE_APP_APIURL}/measurement/${id}/tags`, {
          tags: preparedtags,
        })
        .then(() => {
          this.tagsEditing = false;
          this.measurement.tags = preparedtags;
          this.calculatePath();
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
        });
    },
    tagLocalization(item) {
      if (!prefaultsOptions.includes(item)) {
        return item;
      } else {
        return this.$t(`vibration_analyze_report.${item}`);
      }
    },
    autoFaultTag(item) {
      if (!this.tagsForm.some((i) => i.value.includes(item.value))) {
        this.tagsForm.push({
          value: item.value,
          label: this.$t(`vibration_analyze_report.${item.value}`),
        });
      }
    },
    editTags() {
      this.tagsForm = this.measurement.tags.map((x) => {
        return { value: x, label: this.tagLocalization(x) };
      });
      this.tagsEditing = true;
    },
    dateDate(date) {
      return dayjs(date).format(preferences().localization.dateFormat);
    },
  },
};
</script>
<style scoped>
</style>
<style>
.duckMeasurement .el-card__body {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#favorite-button:hover {
  transform: scale(1.2);
}

#favorite-button .el-loading-spinner .circular {
  height: 26px;
  width: 26px;
}

#favorite-button .el-loading-spinner {
  margin-top: -15px;
}
</style>

